/**
 * LLMArtifactsCard - Artefacts LLM
 * Extrait de Profile.js pour améliorer la maintenabilité
 * AMIRAUX UNIQUEMENT
 */
import React from 'react';
import { FileWarning } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

export const LLMArtifactsCard = () => (
  <Card className="relative bg-amber-950/15 backdrop-blur-xl border-amber-800/40" data-testid="card-llm-artifacts">
    <CardHeader>
      <CardTitle className="text-xl md:text-2xl font-orbitron uppercase tracking-wider text-amber-400 flex items-center">
        <FileWarning className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3" />
        Artefacts LLM
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-sm text-slate-400 mb-4">
        Snapshots des générations contenant des artefacts JSON/HTML résiduels.
        Conservés 7 jours après la dernière erreur. Accessibles uniquement aux Amiraux.
      </p>
      <Button
        onClick={() => window.location.assign('/admin/llm-artifacts')}
        className="bg-amber-500/10 hover:bg-amber-500/20 text-amber-400 border border-amber-500/50 hover:border-amber-400"
        data-testid="btn-open-llm-artifacts"
      >
        <FileWarning className="w-4 h-4 mr-2" />
        Consulter les artefacts détectés
      </Button>
    </CardContent>
  </Card>
);

export default LLMArtifactsCard;
